module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxyZWN0IGZpbGw9IiNmMDAiIGhlaWdodD0iMzIiIHdpZHRoPSIzMiIvPgogICAgPHJlY3QgZmlsbD0iI2ZmZiIgaGVpZ2h0PSI2IiB3aWR0aD0iMjAiIHg9IjYiIHk9IjEzIi8+CiAgICA8cmVjdCBmaWxsPSIjZmZmIiBoZWlnaHQ9IjIwIiB3aWR0aD0iNiIgeD0iMTMiIHk9IjYiLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/images/swiss_flag.svg
// module id = 4wkv
// module chunks = 1